import z from "zod";
/**
 * Bounded at 255 characters, the length Auth0 itself allows a `user_id`, so an
 * id that parses can be stored wherever a product keeps one.
 */
export const Auth0UserIdSchema = z
    .string()
    .min(1)
    .max(255)
    .brand();
//# sourceMappingURL=auth0UserId.js.map